import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import Swal from 'sweetalert2';
import { AuthService } from '../_services/auth.service';
import liff from '@line/liff';
import jwtDecode from 'jwt-decode';
@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private auth: AuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let acc = JSON.parse(localStorage.getItem('currentUser'));
  
        let token: any = localStorage.getItem('token');

        // if (token) {
        //     let decoded: any = jwtDecode(token);
        //     const resetday = new Date('2025-05-02T06:00:00'); 

        //     let date = new Date(decoded.iat * 1000);

        //     const year = date.getFullYear();
        //     const month = String(date.getMonth() + 1).padStart(2, '0'); // เดือนเริ่มที่ 0
        //     const day = String(date.getDate()).padStart(2, '0');

        //     const createdToken = `${year}-${month}-${day}`;

     
        //     // let now = new Date();
        //     // const diffInMs = now.getTime() - date.getTime();
        //     // const diffInDays = diffInMs / (1000 * 60 * 60 * 24); // แปลงเป็นจำนวนวัน
        
        //     // if (diffInDays > 7) {
        //     //     Swal.fire({
        //     //         icon: "error",
        //     //         title: 'Token หมดอายุ',
        //     //         text: 'กรุณา เข้าสู่ระบบใหม่',
        //     //         confirmButtonText: 'ตกลง',
        //     //         allowOutsideClick: false
        //     //     }).then(result => {
        //     //         this.auth.doLogout();
        //     //     });
        //     // }

        //     if (createdToken <= resetday) {
        //         Swal.fire({
        //             icon: "error",
        //             title: 'Token หมดอายุ',
        //             text: 'กรุณา เข้าสู่ระบบใหม่',
        //             confirmButtonText: 'ตกลง',
        //             allowOutsideClick: false
        //         }).then(result => {
        //             this.auth.doLogout();
        //         })
        //     }
        // }

        if (token) {
            let decoded: any = jwtDecode(token);

            const resetday = new Date(2025, 4, 2, 8, 0, 0);// ใช้ T สำหรับรูปแบบ ISO
        
            let createdDate = new Date(decoded.iat * 1000); // เวลาสร้าง token

            console.log(createdDate, resetday);
            

            // เงื่อนไข: ถ้า token ถูกสร้างก่อน resetday หรือ เกิน 7 วัน
            if (createdDate <= resetday ) {
                Swal.fire({
                    icon: "error",
                    title: 'Token หมดอายุ',
                    text: 'กรุณา เข้าสู่ระบบใหม่',
                    confirmButtonText: 'ตกลง',
                    allowOutsideClick: false
                }).then(result => {
                    this.auth.doLogout();
                });
            }
        }

        if (acc && acc.guard == 'SYS') {
            if (this.auth.isLoginSessionExpired()) {
                this.auth.doSignOut();
                Swal.fire({
                    icon: "info",
                    title: 'Session หมดอายุ',
                    text: 'กรุณา เข้าสู่ระบบใหม่',
                    allowOutsideClick: false
                }).then(result => {
                    this.router.navigate(['/system/auth'], { queryParams: { returnUrl: state.url } });
                });
                return false;
            }

            let isExp = this.auth.isTokenExpired();
       
            if (isExp) {
                this.auth.doSignOut();
                Swal.fire({
                    icon: "info",
                    title: 'Session หมดอายุ',
                    text: 'กรุณา เข้าสู่ระบบใหม่',
                    allowOutsideClick: false
                }).then(result => {
                    this.router.navigate(['/system/auth'], { queryParams: { returnUrl: state.url } });
                })
                return false;
            }

            return true;
        }
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/system/auth'], { queryParams: { returnUrl: state.url } });


        return false;
    }


}


